import { api_GET } from "./_api.js";

const acesso_api = {
  get: () => {
    const promise = new Promise((resolve, reject) => {
      api_GET("acesso")
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  getFuncionalidadesAcesso: function (modulo) {
    const promise = new Promise((resolve, reject) => {
      api_GET(`acesso/getFuncionalidadesAcesso/${modulo}`)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });

    return promise;
  },
  getFuncionalidadesRelatorios: function (modulo) {
    const promise = new Promise((resolve, reject) => {
      api_GET(`acesso/getFuncionalidadesRelatorios/${modulo}`)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });

    return promise;
  },
}

export default acesso_api;
